export default {
  open: false,
  entry: {}
};